module.exports = __webpack_public_path__ + "img/luxury@2x.22e12e9.jpg";